/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */



// suggest improvements for this component
// give me the entire code to copy

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate  } from 'react-router-dom';

import { MdPayment, MdEmail } from 'react-icons/md';

import Header from './../components/Header';
import Footer from './../components/Footer';

import { get_event_details, update_event_details,update_event_details_sellerPackage, update_event_details_deposit_only,
    update_event_details_floorPlan } from '../store/reducers/eventDetailsReducer';

import GetSellerConfig from '../components/GetSellerConfig';
import DiagnosticInfo from '../components/DiagnosticInfo';
import Stripe from '../components/Stripe';
import { currencyFormat } from '../components/CurrencyFormat';

import config from '../config';

const Payment = () => {
    const sellerFrontendURL = config.STR_FRONTEND_URL
    const arrCanvasSizes = config.STR_ARR_FLOOR_PLANNER_CANVAS_SIZES
    const sellerEnvironment = config.STR_ENVIRONMENT

    //const { seller } = useSelector(state => state.seller)
    const { userInfo } = useSelector(state => state.auth) 
    const { eventDetails, errorMessage, successMessage } = useSelector(state => state.eventDetails);
    
    const { 
        sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerColorDark, sellerColorMedium, sellerColorLight,
        sellerProductPluralTerm, sellerBoolShowSitePayments, 
    } = GetSellerConfig();

    //console.log(eventDetails)

    // const [state, setState] = useState({
    //     depositGiven: isDeposit, eventName: '', venueName: '', venueAddress: '', eventType: '', eventDate: '', eventStartTime: '',
    //     eventServiceType: '', eventPlaceSettings: '', eventGuestTableclothColor:'', eventNapkinColor: '',
    //     venueManagerContactInfo: '', eventGuestCount: '', eventNotes: ''
    // })
        
    //console.log('payment sellerBoolShowSitePayments ', sellerBoolShowSitePayments)
    //  orderId
    const { state: {price, products, eventDetailsInfo, items, isDeposit, isBalance}} = useLocation()
    //console.log('isBalance ', isBalance, '\n', eventDetailsInfo)
    //console.log('Payment.jsx - isDeposit ', isDeposit, '\nprice', price, '\nproducts', products, '\neventDetailsInfo', eventDetailsInfo)
    //console.log(`isDeposit is a ${typeof isDeposit}:`, isDeposit);
    
    const [paymentMethod, setPaymentMethod] = useState('stripe')
    
    //console.log('Payment.jsx customerId ', customerId) //works

    //console.log('Payments - isDeposit ', isDeposit, 'sellerBoolShowSitePayments ', sellerBoolShowSitePayments)
    //console.log('Payments')
    
    const dispatch = useDispatch()
    const navigate = useNavigate()
    
    useEffect(() => {
        if (userInfo) { 
            // when customer submits order and paymaents are off isDeposit === 'false'
            if (!isDeposit && !isBalance && !sellerBoolShowSitePayments) {
                dispatch(update_event_details_deposit_only({
                    customerId: userInfo.id,
                    depositGiven: false,
                    depositAmountPaid: 0
                }))
                dispatch(update_event_details({
                    customerId: userInfo.id,
                    depositGiven: false,
                    eventName: '', 
                    venueName: '', 
                    venueAddress: '',
                    eventType: '', 
                    eventDate: '', 
                    eventStartTime: '',
                    eventServiceType: '', 
                    eventPlaceSettings: '', 
                    eventGuestTableclothColor: '', 
                    eventBuffetTableclothColor: '',
                    eventNapkinColor: '',
                    venueManagerContactInfo: '',
                    venueDoorCode: '', 
                    eventGuestCount: 0, 
                    eventNotes: '',
                    customMenuProducts: '[]',
                    customMenuInstructions: '',
                    selectedGalleryImages: '[]',
                    otherEventOptions: '[]',
                    eventDetailsSellerNotes: '',
                    tableRequirements: '[]',
                    utensilsAndEquipmentList: '[]',
                    eventStaffList: '[]',
                    invoice: '[]',
                    eventPartsTimeLine: '[]',
                    coupon: '', 
                    couponDescription: '', 
                    couponExpirationDate: '',

                }))
                
                dispatch(update_event_details_sellerPackage({
                    customerId: userInfo.id,
                    title: 'None'
                }))
                
                dispatch(update_event_details_floorPlan({
                    customerId: userInfo.id,
                    floorPlan: '',
                    floorPlanNotes: '',
                    floorPlanCanvasHeight: arrCanvasSizes[0],
                    floorPlanCanvasWidth: arrCanvasSizes[2],
                    floorPlanRoomHeight: arrCanvasSizes[0],
                    floorPlanRoomWidth: arrCanvasSizes[0], 
                }))
               
                // } else {
                //     navigate('/login')   
            } else if (isDeposit) {
                ///update event details deposit given
            }   
       }
    }, [])

    return (
        <div>
            <Header/>
            <div  className="w-full mt-0" style={{ backgroundColor: sellerComponentBackgroundColor }}>
                <div className='w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-0 bg-white rounded-2xl'>
                    <div className='flex flex-wrap md:flex-col-reverse py-1 border rounded-2xl p-4'
                        style={{ 
                            backgroundColor: sellerColorLight,
                            borderColor: sellerColorDark
                        }}>
                        <div className='w-7/12 md:w-full mb-4 border-none border-black'>
                            <div className="flex items-center gap-2 m-2 mb-10">
                                <div>
                                    <MdPayment size={38} style={{ color: sellerColorDark }} />
                                </div>
                                <div>
                                    <div
                                        className="text-2xl font-bold tracking-tight leading-none"
                                        style={{ color: sellerColorDark }}>
                                        Payment
                                    </div>
                                </div>
                            </div>
                            <div className='pr-2 md:pr-0'>
                                <div className='flex flex-wrap'>
                                    <div onClick={() => setPaymentMethod('stripe')} 
                                        className={`hidden w-[20%] border-r cursor-pointer py-8 px-12 
                                            ${paymentMethod === 'stripe' ? 'bg-white':'bg-slate-100'} `} >
                                        <div className='flex flex-col gap-[3px] justify-center items-center'>
                                            <img src={`${sellerFrontendURL}/images/payment/stripe.png`} alt="" />
                                        </div>
                                        <span style={{color: sellerColorDark}}>Stripe</span>
                                    </div>
                                    <div onClick={() => setPaymentMethod('cod')} 
                                        className={`hidden w-[20%] border-r cursor-pointer py-8 px-12 
                                            ${paymentMethod === 'cod' ? 'bg-white':'bg-slate-100'} `} >
                                        <div className='flex flex-col gap-[3px] justify-center items-center'>
                                            <img src={`${sellerFrontendURL}/images/payment/cod.jpg`} alt="cod.jpg" />
                                        </div>
                                        <span className='' style={{color: sellerColorDark}}>COD</span> 
                                    </div>
                                </div> 
                            </div>
                            { 
                                paymentMethod === 'stripe' && 
                                <div>
                                    <DiagnosticInfo parentPage='Payment.jsx' isDeposit={isDeposit} />
                                    <Stripe price={price} products={products} eventDetailsInfo={eventDetailsInfo}   
                                        isDeposit={isDeposit} isBalance={isBalance} />
                                </div>
                            }
                            {
                                paymentMethod === 'cod' && 
                                <div className='w-full px-4 py-8 bg-white shadow-sm'>
                                    <button className='px-10 py-[6px] rounded-sm text-white' style={{backgroundColor: sellerColorDark}}>
                                        Pay Now
                                    </button>
                                </div>
                            }
                        </div>
                        <div className='w-5/12 md:w-full'>
                            <div className='pl-2 md:pl-0 md:mb-0'>
                                <div className='border rounded-2xl m-4 p-5 flex flex-col gap-3' 
                                    style={{
                                        color: sellerColorDark, 
                                        borderColor: sellerColorDark, 
                                        backgroundColor: sellerColorLight
                                    }}>
                                    <div className='font-bold text-xl'>Order Summary</div>
                                    {
                                        //if (isDeposit === 'false' && sellerBoolShowSitePayments === false) {
                                        //className={` ${sellerBoolDepositShowPayments ? 'hidden' : 'font-semibold'} `} 
                                    }
                                    <div className='flex justify-between items-center'>
                                        <div className={` ${isDeposit || isBalance ? 'hidden' : ''} `}>
                                            {items} {sellerProductPluralTerm}
                                        </div>
                                        <div className={` ${isDeposit ? '' : 'hidden'} `}>
                                            Deposit
                                        </div>  
                                        <div className={` ${isBalance ? '' : 'hidden'} `}>
                                            Balance
                                        </div>  
                                        <span className={` ${isDeposit || isBalance || sellerBoolShowSitePayments ? '' : 'hidden'} font-semibold`}>
                                            {currencyFormat.format(price)}
                                        </span>
                                    </div>
                                    {
                                        // <span className={` ${isDeposit === 'true' || sellerBoolShowSitePayments ? '' : 'hidden'} font-semibold`}>
                                        // flex justify-between items-center font-semibold
                                    }
                                    <div className={` ${isDeposit || isBalance || sellerBoolShowSitePayments ? '' : 'hidden'} 
                                        flex justify-between items-center font-semibold`}>
                                        <span>Total Amount</span>
                                        <span className='text-lg' style={{color: sellerColorDark}}>
                                            {currencyFormat.format(price)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer/>
        </div>
    );
};

export default Payment;








